module.exports = __webpack_public_path__ + "static/media/cellphone_screen-marketing.847b5eec.png";